export const handleNavScroll = () => {
	(($) => {
		const eventSections = [
			'event_description',
			'agenda',
			'speakers',
			'sponsors',
			'additional_information',
		]

		const menuElements = []
		eventSections.forEach(section => {
			menuElements.push(`menu_item_${section}`)
		})

		const toggleOffActiveClassOnNavElements = (menuElements) => {
			menuElements.forEach(element => {
				const domElement = document.getElementById(element)
				if (domElement) {
					domElement.classList.remove('active')
				}
			})
		}

		const getElementBounds = (elementId) => {
			let bounds = null;

			const domElement = $(`#${elementId}`);
			if (domElement.hasOwnProperty('length')) {
				const top = domElement.offset().top;
				const height = document.getElementById(elementId).offsetHeight;
				const bottom = top + height;
				bounds = {
					top: top,
					bottom: bottom,
					height: height
				}
			}

			return bounds;
		}

		let element      = null;

		setTimeout(() => {
			const docViewTop = $(window).scrollTop();

			eventSections.forEach(section => {
				if (document.getElementById(section)) {
					const sectionBounds = getElementBounds(section);
					const TRIGGER_ELEMENT_HEIGHT = 200;
					if (docViewTop >= sectionBounds.top - TRIGGER_ELEMENT_HEIGHT && docViewTop < sectionBounds.bottom) {
						element = section;
					}
				}
			})

			if (element) {
				toggleOffActiveClassOnNavElements(menuElements);
				const menuElement = document.getElementById(`menu_item_${element}`);
				if (menuElement) {
					menuElement.classList.add('active')
				}
			}
		}, 1000)
	})(window.jQuery);
}
